<template>
    <div class="home">
        <Header/>
        <Body/>
        <Footer/>
    </div>
</template>

<script>
    import Header from './components/core/Header.vue'
    import Footer from './components/core/Footer.vue'
    import Body from './components/core/Body.vue'


    export default {
        components: {
            Header,
            Body,
            Footer,
        },
        data() {
            return {
            }
        },

    }
</script>

<style>

</style>
